const mobileHandler = () => {

    const mobileTrigger = document.querySelector('.header__mobile-trigger');
    const mobileMenu = document.querySelector('.header__navigation-mobile');
    const overlay = document.querySelector('.overlay');

    mobileTrigger.addEventListener('click', () => {
        mobileMenu.classList.toggle('hide');
        overlay.classList.toggle('overlay--open');
    });

};

export default mobileHandler;